import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { Container } from './Container'

export const MainContent = styled(Container).attrs({ as: 'main', variant: 'xxlg' })`
  padding: ${getToken('space-m')};
  padding-top: ${getToken('space-l')};
`
